import FormV2 from "../../form-v2/form.component";
import useFormV2 from "../../form-v2/form.hook"


export const SpecialLpCronModal = ({ clinicGroupId, onClose, lang }) => {
	const form = useFormV2({
		autoSubmit: {
			method: 'post',
			url: '/clinic-groups/lab-portalen-run-cron/special',
			onBeforeSubmit: (data) => {
				data.groupId = clinicGroupId;

				return data;
			},
			onAfterSubmit: () => {
				onClose?.();
			}
		},
		title: 'Run Special LP Cron',
		buttons: {
			submit: {
				text: 'Run'
			},
			reset: {
				isShown: true,
				text: 'Cancel',
				callback: onClose
			}
		}
	}, {
		ssn: {
			type: 'ssn',
			label: 'SSN',
			isRequired: true,
		},
		from: {
			type: 'date',
			label: 'From Date',
			isRequired: true,
		},
		to: {
			type: 'date',
			label: 'To Date',
			isRequired: true,
		}
	});

	return <FormV2 data={form} lang={lang} />
}